import { render, staticRenderFns } from "./mycourse_group.vue?vue&type=template&id=51c47268&scoped=true&"
import script from "./mycourse_group.vue?vue&type=script&lang=js&"
export * from "./mycourse_group.vue?vue&type=script&lang=js&"
import style0 from "./mycourse_group.vue?vue&type=style&index=0&id=51c47268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c47268",
  null
  
)

export default component.exports